import allowed from "./component/modulesData.json";
import { subModuleData } from "./component/defaultSideNavData";

// Hardcoded submodules that should always be accessible regardless of backend config
const HARDCODED_ACCESSIBLE_SUBMODULES = {
  // childManagement: ["child360"],
};

// Phase 3 reuses established Timetable access until deployments add the new
// granular label keys. This remains permission-based and never checks job titles.
const SUBMODULE_ACCESS_FALLBACKS = {
  timetable: {
    publishVersions: "timetableBuilder",
    managementOverview: "overview",
    operationalPlanning: "overview",
    eventsDuties: "operationalPlanning",
  },
};

const MODULE_DISPLAY_ORDER = [
  "childManagement",
  "daycare",
  "staffManagement",
  "timetable",
  "examsEvents",
  "activities",
  "reports",
  "transportation",
  "mealManagement",
  "access",
];

const moduleOrderIndex = (value) => {
  const index = MODULE_DISPLAY_ORDER.indexOf(value);
  return index === -1 ? MODULE_DISPLAY_ORDER.length : index;
};

export const allowedModulesHandler = (data) => {
  const finalData = [],
    finalSubModulesData = [];
  const accountType = typeof window !== "undefined" ? window.localStorage.getItem("accountType") : "";
  allowed.data.forEach((ele) => {
    console.log("module data", ele);
    const moduleData = data.modules[ele.name],
      subModules = moduleData?.subModules;
    console.log("module Data && submodule data", { moduleData, subModuleData });
    const eachModule = [];
    if (moduleData?.accessible) {
      if (ele.type) {
        finalData.push({
          path: ele.path,
          name: moduleData.label,
          value: ele.name,
          type: ele.type,
          data: ele.data,
        });
      } else {
        finalData.push({ path: ele.path, name: moduleData.label, value: ele.name });
      }

      console.log("login data error", subModuleData, ele.name, subModules);
      const hardcodedForModule = HARDCODED_ACCESSIBLE_SUBMODULES[ele.name] || [];
      subModuleData[ele.name].forEach((sub, index) => {
        if (sub.name === "profile") return;
        if (sub.name === "myTimetable" && !["professional", "daycare"].includes(accountType)) return;
        const isManagerTimetable = sub.name === "myTimetable" && accountType === "daycare";
        const isHardcoded = hardcodedForModule.includes(sub.name) || isManagerTimetable;
        const legacyAlumniConfig = ele.name === "childManagement" && sub.name === "alumni"
          ? data.modules?.daycare?.subModules?.alumni
          : null;
        const legacyLearningGroupConfig = ele.name === "daycare" && sub.name === "learningGroups" && data.modules?.timetable?.accessible
          ? data.modules.timetable.subModules?.learningGroups
          : null;
        const isExamsEvents = ele.name === "examsEvents";
        const hasConfiguredNavigation = isExamsEvents && Object.prototype.hasOwnProperty.call(subModules || {}, sub.name);
        const sourceModule = isExamsEvents || (ele.name === "reports" && sub.name === "managementOverview")
          ? data.modules?.timetable : moduleData;
        const sourceSubModules = sourceModule?.accessible ? sourceModule.subModules : null;
        const configuredSubModule = hasConfiguredNavigation ? subModules[sub.name] : sourceSubModules?.[sub.name] || legacyAlumniConfig || legacyLearningGroupConfig;
        const configuredLabel = ele.name === "reports" && sub.name === "managementOverview"
          ? subModules?.[sub.name]?.label || configuredSubModule?.label
          : configuredSubModule?.label;
        const fallbackName = SUBMODULE_ACCESS_FALLBACKS[isExamsEvents || sub.name === "managementOverview" ? "timetable" : ele.name]?.[sub.name];
        const hasModuleFallback = Object.prototype.hasOwnProperty.call(SUBMODULE_ACCESS_FALLBACKS[ele.name] || {}, sub.name) && fallbackName === null;
        const hasAccessibleFallback = fallbackName && (sub.name !== "operationalPlanning" || accountType === "daycare")
          ? sourceSubModules?.[fallbackName]?.accessible : hasModuleFallback;
        const professionalPermissionKey = sub.name === "eventsDuties" ? "operationalPlanning" : sub.name;
        const professionalMayAccess = accountType !== "professional" || Boolean(sourceSubModules?.[professionalPermissionKey]?.accessible);
        const permitted = isExamsEvents && hasConfiguredNavigation
          ? Boolean(configuredSubModule?.accessible && professionalMayAccess)
          : sub.name === "eventsDuties"
            ? Boolean(sourceSubModules?.operationalPlanning?.accessible)
            : configuredSubModule?.accessible || isHardcoded || hasAccessibleFallback;
        if (permitted) {
          const configuredIconIndex = ele.submodules?.indexOf(sub.name);
          const configuredIcon =
            configuredIconIndex >= 0 ? ele.icons?.[configuredIconIndex] : "";
          console.log("each module", subModules?.[sub.name])
          eachModule.push({
            ...sub,
            translationKey: sub.name,
            name: sub.name === "studentAccess" ? "Student Access" : sub.name === "driverAccess" ? "Driver Access" : isHardcoded && !configuredLabel ? "Child 360" : configuredLabel || sub.name,
            icon: sub.icon || configuredIcon || ele.icons?.[index] || "no",
          });
        }
      });
    }

    finalSubModulesData.push([ele.baseurl, ele.sideNav, [...eachModule]]);
  });
  console.log("login data->final submodules data", finalSubModulesData);
  console.log("login data->final data", finalData);

  const visibleModules = finalData.filter(item => {
    const module = allowed.data.find(({ name }) => name === item.value);
    const matchingModule = finalSubModulesData.find(ele => ele[0] === module?.baseurl);

    if (!matchingModule?.[2]?.length) return false;
    item.path = matchingModule[2][0].url;
    return true;
  }).sort((left, right) => moduleOrderIndex(left.value) - moduleOrderIndex(right.value));

  return [visibleModules, finalSubModulesData];
};
